<style lang="scss">
.prompt {
    .content {
        padding-top: 40px;
        > h4 {
            font-size: 14px;
            margin: 0;
            line-height: 14px;
        }
        .code {
            font-size: 18px;
            margin: 10px auto 20px;
            color: #505060;
            line-height: 14px;
        }
        .tip {
            font-size: 14px;
            margin: 0 auto 20px auto;
            color: #84848b;
            font-weight: 400;
            line-height: 14px;
        }
    }
    .header {
        color: #d19f4e;
        font-size: 20px;
        text-align: center;
        padding-top: 30px;
        line-height: 20px;
    }
    .footer {
        text-align: center !important;
    }
    .btn-ensure {
        background-color: #d19f4e;
        margin-right: 0 !important;
        color: white;
        &:hover{
            background: #ECB845;
        }
    }
}
</style>
<template>
    <modal class="prompt" :title="title" :show.sync="show" :close-show="true" height="235px" :on-sure="onSure" :on-cancel="onCancel">
        <div class="header" slot="header">
            兑换成功
        </div>
        <template slot="content">
            <h4>请牢记兑换码</h4>
            <h3 class="code">{{message}}</h3>
            <p class="tip">该兑换码已发送至您的搜狐VIP邮箱中</p>
        </template>
        <div class="footer" slot="footer">
            <a href="javscript:void(0)" class="btn btn-ensure" @click.prevent="sure">确定</a>
        </div>
    </modal>
</template>

<script type="text/javascript">
export default {
    name: 'prompt',
    props: {
        // title: {
        //     type: String,
        //     default: ''
        // },
        // message: {
        //     type: String,
        //     default: ''
        // },
        // show: {
        //     type: Boolean,
        //     default: false
        // },

        // closeShow: {
        //     type: Boolean,
        //     default: true
        // },
        // onCancel: {
        //     type: Function
        // },
        // onSure: {
        //     type: Function
        // }
    },
    data() {
        return {
            show:true,
            closeShow:true
        }
    },
    methods: {
        sure() {
            this.show = false
            this.$emit('update:show', false)
            if (this.onSure) {
                this.onSure()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/prompt.vue